import React from "react"
import Block from "@bappweb/block"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import "../../assets/style.scss"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import CampaignCarousel from "./campaignCarousel"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue } from "@smpu-web/utils/utils"

const Notes = () => {
    let size = useDeviceSize()
    size = size === undefined ? Sizes.md : size
    const isHigherThanMd = size > Sizes.md ? true : false

    const sessionData = useAppSelector((state) => state.sessionData.response)

    return (
        <Block type="section" className="notes-page-wrapper" id="landing-page-wrapper">
            {isHigherThanMd ? <Block type="section" className="section general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "PosBasvuru.Landing.CampaignText.Middle") }} /> :
                <Block type="section" className="container center-section">
                    <Block dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "PosBasvuru.Landing.CampaignText.Carousel.Top") }} />
                    <CampaignCarousel />
                </Block>
            }
            <Block type="section" className="section general-features second-general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "PosBasvuru.Landing.CampaignText.Top") }} />
        </Block>
    )
}

export default Notes
